import {ChangeDetectionStrategy, Component, OnChanges, inject, input, signal} from "@angular/core";
import {ThreePLServiceActionsService} from "../../services/threepl-service-actions.service";
import {TimelineLog} from "../../../../commons/angular/components/bringoz-timeline-logs-table-row/bringoz-timeline-logs-table-row.component";

@Component({
  selector: "app-threepl-service-timeline",
  templateUrl: "./threepl-service-timeline.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreeplServiceTimelineComponent implements OnChanges {
  readonly serviceId = input<string>();

  readonly timeline = signal<TimelineLog[] | undefined>(undefined);

  private readonly actions = inject(ThreePLServiceActionsService);

  ngOnChanges(): void {
    const serviceId = this.serviceId();
    if (!serviceId) {
      return;
    }
    this.actions.getTimeline(serviceId)
      .then((timeline) => {
        if (this.serviceId() === serviceId) {
          this.timeline.set(timeline);
        }
      })
      .catch(() => undefined);
  }
}
